// extracted by mini-css-extract-plugin
export default {"carousel_container":"Carousel3D_carousel_container__1VvNp"};